import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { GET_LEAD } from "types/actions/leadMaster.action";

  export const getAllLeads = (
    search: string,
    offset: number,
  ) => {
    return (dispatch: Dispatch<AppActions>) => {
      dispatch(fetchStart());
      jwtAxios
        .get("leads", {
          params: {
            searchTerm: search,
            offset,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            dispatch(fetchSuccess());
            dispatch({ type: GET_LEAD, payload: response.data.data });
          } else {
            dispatch(fetchError("Something went wrong, Please try again!"));
          }
        })
        .catch((error) => {
          dispatch(fetchError(error.message));
        });
    };
  };
  
  